import {
    Box, Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText, Paper, Popover,
    Typography
} from "@mui/material";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";

const ProfileMenuDropdown = ({
                                 menuId,
                                 menuItems,
                                 anchorEl,
                                 handleMenuClose,
                                 avatar,
                                 email,
                                 username,
                                 logoutButton
                             }) => {
    const isMenuOpen = Boolean(anchorEl);

    return <Popover
        id={menuId}
        open={isMenuOpen}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}>
        <Paper>
            <Box
                sx={{flexGrow: 1}}
            >
                <Grid container justifyContent={"space-between"} gap={3} sx={{padding: "1.5rem"}} alignItems={"center"}>
                    <Grid item container alignItems={"center"}>
                        <Grid item mr={1}>{avatar}</Grid>
                        <Grid item>
                            <Typography variant="body2" fontWeight={600} component="div">{username}</Typography>
                            <Typography variant="body2" component="div">{email}</Typography>
                        </Grid>
                    </Grid>
                    {logoutButton ? <Grid item>
                        {logoutButton}
                    </Grid> : null}
                </Grid>
                {menuItems.length > 0 ? <Divider/> : null}
                <List>
                    {menuItems.map((menuItem, index) => (
                        <ListItemButton key={`${menuId}-${index}`}
                                        onClick={menuItem.handleOnClick}
                                        sx={{ py: 0.5, minHeight: 32}}>
                            <ListItemIcon sx={{ color: 'inherit' }}>
                                {menuItem.icon}
                            </ListItemIcon>
                            <ListItemText
                                primary={menuItem.text}
                            />
                        </ListItemButton>
                    ))}
                </List>
            </Box>
        </Paper>
    </Popover>
};

ProfileMenuDropdown.propTypes = {
    menuId: PropTypes.string.isRequired,
    avatar: PropTypes.element.isRequired,
    username: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    logoutButton: PropTypes.element,
    menuItems: PropTypes.arrayOf(PropTypes.shape(
        {
            handleOnClick: PropTypes.func,
            icon: PropTypes.element,
            text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
        }
    )).isRequired,
};

export default ProfileMenuDropdown;